import React, { createContext, useContext } from 'react';
import { Emitter } from 'rettime';

export const createEmitter = (): Emitter<AppEvents> => new Emitter<AppEvents>();

const shellEmitter = createEmitter();

const EmitterContext = createContext<Emitter<AppEvents> | null>(null);

export const EmitterProvider = ({
  value = shellEmitter,
  children,
}: {
  value?: Emitter<AppEvents>;
  children: JSX.Element;
}): JSX.Element => (
  <EmitterContext.Provider value={value}>{children}</EmitterContext.Provider>
);

export const useEmitter = (): Emitter<AppEvents> | null =>
  useContext(EmitterContext);
